import React, { useState } from 'react';
import {
  IconButton,
  Stack,
  Text,
  useBreakpointValue,
  Flex,
} from '@chakra-ui/react';
import { ArrowLeftIcon, ArrowRightIcon } from '@chakra-ui/icons';
import { useIsMobile } from '../hooks/isMobile';
import { useIsTablet } from '../hooks/isTablet';

type CarouselProps = {};

const Carousel: React.FC<CarouselProps> = ({ children, ...rest }) => {
  const [index, setIndex] = useState<number>(0);
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  const top = useBreakpointValue({ base: '90%', md: '50%' });
  const side = useBreakpointValue({ base: '30%', md: '10px' });

  if (children == null || (children as any[]).length == null) {
    return <Text>Wrong children</Text>;
  }

  // Mobile navigation controls
  const mobileNavigation = (
    <Flex justify="space-evenly" width="100%" mt={2} mb={2}>
      <IconButton
        aria-label="left-arrow"
        colorScheme="messenger"
        borderRadius="full"
        onClick={() => {
          if (index <= 0) {
            return;
          }
          setIndex(index - 1);
        }}
      >
        <ArrowLeftIcon />
      </IconButton>

      <Text>
        {index + 1}/{(children as any[]).length}
      </Text>

      <IconButton
        aria-label="right-arrow"
        colorScheme="messenger"
        borderRadius="full"
        onClick={() => {
          if (index >= (children as any[]).length - 1) {
            return;
          }
          setIndex(index + 1);
        }}
      >
        <ArrowRightIcon />
      </IconButton>
    </Flex>
  );

  // Desktop navigation controls (absolute positioned)
  const desktopNavigation = (
    <Flex justify="space-evenly" width="100%" mt={2} mb={2}>
      <IconButton
        aria-label="left-arrow"
        colorScheme="messenger"
        borderRadius="full"
        position="absolute"
        left={'-10px'}
        top={top}
        transform={'translate(0%, -50%)'}
        zIndex={2}
        onClick={() => {
          if (index <= 0) {
            return;
          }
          setIndex(index - 1);
        }}
      >
        <ArrowLeftIcon />
      </IconButton>
      <Text>
        {index + 1}/{(children as any[]).length}
      </Text>
      <IconButton
        aria-label="right-arrow"
        colorScheme="messenger"
        borderRadius="full"
        position="absolute"
        right={'-10px'}
        top={top}
        transform={'translate(0%, -50%)'}
        zIndex={2}
        onClick={() => {
          if (index >= (children as any[]).length - 1) {
            return;
          }
          setIndex(index + 1);
        }}
      >
        <ArrowRightIcon />
      </IconButton>
    </Flex>
  );

  return (
    <Stack
      position="relative"
      w="full"
      direction="column"
      justify="center"
      alignItems="center"
      gap={4}
      {...rest}
    >
      <div>{children && (children as any[])[index]}</div>
      {isMobile || isTablet ? mobileNavigation : desktopNavigation}
    </Stack>
  );
};

export default Carousel;
export { Carousel };
